import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import toObject from 'dayjs/plugin/toObject';
import relativeTime from 'dayjs/plugin/relativeTime';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';

import 'dayjs/locale/en';
import 'dayjs/locale/pt-br';

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(toObject);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

/**
 * Localize format.
 */
dayjs.extend((options, target, factory) => {
  /**
   * Merge default formats with our "Locale" ones.
   *
   * LT - Locale Time
   * LD - Locale Date
   * LDT - Locale DateTime
   */

  factory.Ls.en.formats = {
    ...factory.Ls.en.formats,
    LT: 'h:mm a',
    LD: 'MM/DD/YYYY',
    LDT: 'MM/DD/YYYY h:mm a',
    INTL: 'YYYY-MM-DD HH:mm',
  };

  factory.Ls['pt-br'].formats = {
    ...factory.Ls['pt-br'].formats,
    LT: 'HH:mm',
    LD: 'DD/MM/YYYY',
    LDT: 'DD/MM/YYYY HH:mm',
    INTL: 'YYYY-MM-DD HH:mm',
  };

  /**
   * Proxy dayjs format to read first our custom formats.
   */
  const parentFormat = target.prototype.format;
  target.prototype.format = function (formatStr = 'LD') {
    const { formats = {} } = this.$locale();

    return parentFormat.call(this, formats[formatStr] || formatStr);
  };

  target.prototype.getFormat = function (formatStr = 'LD') {
    const { formats = {} } = this.$locale();

    return formats[formatStr];
  };
});

dayjs.locale(BulldeskSettings.locale === 'en' ? 'en' : 'pt-br');

export default dayjs;
